import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export default function BookingIcon({
  height = 25,
  width = 24,
  color = 'inherit',
  path,
  ...props
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.5 8V5.75C22.5 5.15326 22.2629 4.58097 21.841 4.15901C21.419 3.73705 20.8467 3.5 20.25 3.5H17.25V2.75C17.25 2.55109 17.171 2.36032 17.0303 2.21967C16.8897 2.07902 16.6989 2 16.5 2C16.3011 2 16.1103 2.07902 15.9697 2.21967C15.829 2.36032 15.75 2.55109 15.75 2.75V3.5H8.25V2.75C8.25 2.55109 8.17098 2.36032 8.03033 2.21967C7.88968 2.07902 7.69891 2 7.5 2C7.30109 2 7.11032 2.07902 6.96967 2.21967C6.82902 2.36032 6.75 2.55109 6.75 2.75V3.5H3.75C3.15326 3.5 2.58097 3.73705 2.15901 4.15901C1.73705 4.58097 1.5 5.15326 1.5 5.75V8H22.5Z"
        fill={color}
      />
      <path
        d="M1.5 9.5V20.75C1.5 21.3467 1.73705 21.919 2.15901 22.341C2.58097 22.7629 3.15326 23 3.75 23H20.25C20.8467 23 21.419 22.7629 21.841 22.341C22.2629 21.919 22.5 21.3467 22.5 20.75V9.5H1.5ZM16.2375 13.8193L10.9875 18.3193C10.844 18.4419 10.6595 18.506 10.4708 18.4986C10.2822 18.4913 10.1032 18.413 9.96975 18.2795L7.71975 16.0295C7.58313 15.888 7.50754 15.6986 7.50924 15.5019C7.51095 15.3053 7.58983 15.1172 7.72889 14.9781C7.86794 14.8391 8.05605 14.7602 8.2527 14.7585C8.44935 14.7568 8.6388 14.8324 8.78025 14.969L10.5398 16.7285L15.2648 12.6785C15.3391 12.6115 15.4261 12.56 15.5207 12.5272C15.6153 12.4943 15.7155 12.4807 15.8154 12.4872C15.9153 12.4936 16.0129 12.52 16.1024 12.5648C16.1919 12.6096 16.2716 12.6719 16.3367 12.7479C16.4018 12.824 16.451 12.9123 16.4814 13.0077C16.5118 13.1031 16.5229 13.2036 16.5138 13.3033C16.5048 13.403 16.4759 13.4999 16.4288 13.5882C16.3817 13.6766 16.3175 13.7546 16.2397 13.8177L16.2375 13.8193Z"
        fill={color}
      />
    </svg>
  );
}
